import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import './Login.css';
import looogo from './images/CompanyLogo.svg';
import goo from './images/icons8-google-48.png';
import gith from './images/icons8-github-94.png';
import CIR1 from './images/CIR1.png';
import { toast } from 'react-toastify';

function Login() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://localhost:8000/api/auth/login', formData);
            console.log(response.data);
            toast.success('Login successful!');
            navigate('/'); // Redirect to home 
        } catch (error) {
            console.error('Login error:', error.response.data);
            toast.error(error.response.data.message || 'Login failed');
          }
    };

    return (
        <div className="login-container">
            <Link to="/">
                <img src={looogo} className="looogo" alt="Logo" />
            </Link>
            <div className="left">
                <h1>Welcome Back .!</h1>
                <Link to="/" className="skip-lag">Skip the lag ?</Link>
                <div className="dotted-line"></div>
            </div>
            <div className="right">
                <div className="blur-background"></div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <h2>Login</h2>
                    <p>Glad you're back.!</p>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder="Username"
                        required
                    />
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Password"
                        required
                    />
                    <div className="remember-me">
                        <input type="checkbox" id="remember" />
                        <label htmlFor="remember">Remember me</label>
                    </div>
                    <button type="submit" className="login-button">Login</button>
                    <Link to="/pass" className="forgot-password">Forgot password ?</Link>
                    <div className="alternative-login">
                        <p>Or</p>
                        <div className="socialicons">
                            <img src={goo} alt="Google" />
                            <img src={gith} alt="GitHub" />
                        </div>
                    </div>
                    <p>
                        Don’t have an account ? <Link to="/signup">Signup</Link>
                    </p>
                    <div className="footer-links">
                        <a href="/terms">Terms & Conditions</a>
                        <a href="/support">Support</a>
                        <a href="/customer-care">Customer Care</a>
                    </div>
                </form>
            </div>
            <img src={CIR1} className="circle ppurple" alt="Decorative" />
            <div className="circle wwhite"></div>
            <div className="circle ppu"></div>
            <div className="circle whh"></div>
            <div className="circle puur"></div>
            <div className="circle purrr"></div>
        </div>
    );
}

export default Login;